import React from "react";
//#region types
import { RecurringInvoiceDraftFooterProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { StyleEnums } from "models/enums";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { WizardFormFooter } from "components/common";
import { useNavigate, useLocation } from "react-router-dom";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const RecurringInvoiceDraftFooter: React.FC<RecurringInvoiceDraftFooterProps> = (props) => {
  const { invoiceId, submitInvoice, reloadInvoice, toggleRecurringInvoiceState, isFormLoading, status, wizardProps } =
    props;

  const location = useLocation();
  const navigate = useNavigate();

  const isRecurringInvoiceInactive = status === WintSuperkollAPIModel.RecurringInvoiceState.Stopped;
  const isRecurringInvoiceActive = status === WintSuperkollAPIModel.RecurringInvoiceState.Ongoing;

  const onRecurringInvoiceStopped = () => {
    navigate(UrlHelper.formatPath(`/RecurringInvoice/${invoiceId}`), {
      replace: true,
      state: { background: location },
    });
  };

  return (
    <WizardFormFooter
      actions={
        isRecurringInvoiceInactive
          ? []
          : [
              {
                text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Save),
                onClick: submitInvoice,
                type: StyleEnums.DisplayType.Info,
                isDisabled: isFormLoading,
                successMessage: TranslationKeys.Invoice.SaveSuccessMessage,
                onActionSuccess: reloadInvoice,
              },
              isRecurringInvoiceActive
                ? {
                    text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Stop),
                    onClick: toggleRecurringInvoiceState,
                    type: StyleEnums.DisplayType.Danger,
                    successMessage: TranslationKeys.Invoice.RecurringStoppedMessage,
                    onActionSuccess: onRecurringInvoiceStopped,
                  }
                : {
                    text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Start),
                    onClick: toggleRecurringInvoiceState,
                    type: StyleEnums.DisplayType.Success,
                    isDisabled: isFormLoading,
                    successMessage: TranslationKeys.Invoice.RecurringStartedMessage,
                    onActionSuccess: reloadInvoice,
                  },
            ]
      }
      wizardProps={wizardProps}
    />
  );
};

export default RecurringInvoiceDraftFooter;
